$(document).ready(function () {
  const dropdownTrigger = $('.dropdown-trigger');
  const header = $('.header');

  function showDropdown() {
    if ($(window).width() > 991) {
      dropdownTrigger
        .on('mouseenter', function () {
          header.addClass('scrolled');
          $(this).find('.dropdown-submenu').addClass('show');
          $(this).find('.fa-chevron-down').addClass('inverted');
        })
        .on('mouseleave', function () {
          let scroll = $(window).scrollTop();
          if (scroll === 0) {
            header.removeClass('scrolled');
          }
          $(this).find('.dropdown-submenu').removeClass('show');
          $(this).find('.fa-chevron-down').removeClass('inverted');
        });
    } else {
      dropdownTrigger.on('click', function () {
        $(this).find('.dropdown-submenu').toggleClass('show');
        $(this).find('.fa-chevron-down').toggleClass('inverted');

      })
    }
    // dropdownTrigger.on('click', function (e) {
    //     e.preventDefault();
    // });
  }

  showDropdown();
  $(window).resize(function () {
    dropdownTrigger.unbind();
    showDropdown();
  });

  function toTopBtnHandler() {
    if ($(window).width() > 1200) return false;

    const viewHeight = $(document).height(),
      $badge = $('.promo-badge'),
      toTopBtnHeight = $badge.height(),
      bottomFooterHeight = $('.footer-bottom').innerHeight();

    $(window).scroll(function () {
      if (($(window).scrollTop() + $(window).height()) + toTopBtnHeight >= $(document).height()) {
        $badge.css('bottom', bottomFooterHeight);
      } else {
        $badge.css('bottom', 0);
      }
    });
  }

  toTopBtnHandler();

  // ******* Main Navigation - Hover Effects ******* //
  const navMenuItem = $("header .nav-menu");
  if ($(window).width() > 991) {
    navMenuItem.mouseover(() => {
      header.addClass('scrolled');
    });
    $(window).scroll(() => {
      header.addClass('scrolled');
    });
  }

  // Disable right click
  document.addEventListener('contextmenu', event => event.preventDefault());
});
